const getPreferenceCenterFormEmailInput = require("./getPreferenceCenterFormEmailInput");
const getLabelForInput = require("../dom/getLabelForInput");
const scrollElementIntoView = require("../dom/scrollElementIntoView");

/**
 * @param preferenceCenterForm {HTMLFormElement}
 * @return {void}
 */
module.exports = function showPreferenceCenterFormEmailError(preferenceCenterForm) {
    const emailInput = getPreferenceCenterFormEmailInput(preferenceCenterForm);
    const emailLabel = getLabelForInput(emailInput);

    emailInput.classList.add("invalid");
    emailLabel.classList.add("invalid");

    scrollElementIntoView(emailInput);
}